module.exports = __webpack_public_path__ + "img/156.0c7195dd.jpg";